// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"2aeeff41","660":"2aeeff41"}[chunkId] + ".chunk.css";
};